import { Link } from "react-router-dom";
import { useCart } from "@/hooks/useCart";

/**
 * Icono de carrito de compra con contador de artículos.
 * Reutilizable en el header móvil y en la barra lateral de escritorio.
 */
export default function CartIcon() {
  const { totalItems } = useCart();

  return (
    <Link
      to="/carrito"
      aria-label={`Carrito de compra, ${totalItems} ${totalItems === 1 ? "artículo" : "artículos"}`}
      className="relative flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100"
    >
      <i className="ri-shopping-cart-2-line text-xl"></i>
      {totalItems > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-accent-500 px-1 text-[10px] font-bold leading-none text-white">
          {totalItems > 99 ? "99+" : totalItems}
        </span>
      )}
    </Link>
  );
}